import React from "react";
import Footer from "../../../components/molecules/footer/Footer";
import Header from "../../../components/molecules/header/Header";

const NoAutorizado = () => {
  return (
    <>
      <div className="vh-100" role="main" data-landmark-index="4">
        <Header></Header>
        <p>NO DISPONES DE PERMISOS</p>
        <Footer></Footer>
      </div>
    </>
  );
};

export default NoAutorizado;
